import { Box, Button, Stack, Text, styled } from '@ltvco/refresh-lib/theme';
import React from 'react';

import { MoreWaysSection, MoreWaysSectionItem } from './MoreWaysSection';

interface EmptyStateProps {
  image: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: (event: React.MouseEvent<HTMLElement>) => void;
  actionIcon?: React.ReactNode;
  children?: React.ReactNode;
  items?: MoreWaysSectionItem[];
}

const Container = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(1.5),
}));

export const EmptyState = ({
  image,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon,
  children,
  items,
}: EmptyStateProps) => (
  <Stack mt={3} spacing={3}>
    <Container>
      <img src={image} alt={title} width={120} />
      <Text variant="h4" fontWeight="bold">
        {title}
      </Text>
      <Text variant="body2" color="text.secondary">
        {description}
      </Text>
      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            fontWeight: 'bold',
            px: 3,
            mt: 1,
            gap: actionIcon ? 1 : 0,
          }}
        >
          {actionIcon}
          {actionLabel}
        </Button>
      )}
      {!children && <MoreWaysSection items={items} />}
    </Container>
    {children}
  </Stack>
);
